import { _x, sprintf } from '@wordpress/i18n';

document.addEventListener('findstrLoaded', () => {
  const findstr = window.findstr;
  const fortFields = document.querySelectorAll('.findstr-field-sort');

  if (findstr && 0 < fortFields.length) {
    findstr.hooks.addFilter(
      'findstrSortLabel',
      'laval-sort',
      (sortLabel, option, direction) => {
        let label = sortLabel;
        const directionLabel =
          direction === 'asc'
            ? _x('(ascendant)', 'Sort direction label', 'vtx')
            : _x('(descendant)', 'Sort direction label', 'vtx');

        switch (option) {
          case 'post_date':
            label = sprintf(
              /* translators: %s: Sort direction label */
              _x('Date %s', 'Sort label', 'vtx'),
              directionLabel
            );
            break;
          case 'release_date':
            label = sprintf(
              /* translators: %s: Sort direction label */
              _x('Release date %s', 'Sort label', 'vtx'),
              directionLabel
            );
            break;
          case 'vote_average':
            label = sprintf(
              /* translators: %s: Sort direction label */
              _x('Vote average %s', 'Sort label', 'vtx'),
              directionLabel
            );
            break;
        }

        return label;
      }
    );
  }
});
